import { z } from 'zod/v4'
import { Potential } from '@/utils/detail/potential'

const potentialSchema = z.enum(Potential)

export default potentialSchema
